<template>
  <div>
    <div style="color: #fccc66">乡镇种植面积占比</div>
    <div id="rown-ratio-container" style="height: 270px"></div>
  </div>
</template>
<script>
import Charts from '@jiaminghi/charts'
export default {
  data() {
    return {
      option: {
        title: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: 120,
            startAngle: 40,
            center: ['50%', '54%'],
            data: [
              { name: '水湖镇', value: 23.63 },
              { name: '罗塘乡', value: 13.76 },
              { name: '左店镇', value: 9.27 },
              { name: '岗集镇', value: 1.4 },
              { name: '杨庙镇', value: 0.77 },
              { name: '其他', value: 49 },
              { name: '双墩镇', value: 0.55 },
            ],
            insideLabel: {
              show: true,
            },
          },
        ],
      },
    }
  },
  mounted() {
    const container = document.getElementById('rown-ratio-container')
    const myChart = new Charts(container)
    myChart.setOption(this.option)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/summary-zone/town-ratio.vue